<div *ngIf="subscription && ((subscription.templateType && !subscription.templateType.includes('TRIAL')) || !subscription.templateType)"
[ngClass]="{'automation-active': !isFuture, 'automation-future': isFuture,
'automation-recurring': subscription.templateType === 'RECURRING', 'automation-prepaid': subscription.templateType === 'ONETIME'}">
  <ng-container *ngIf="!isFuture">
    <div class="d-flex align-items-center">
      <div class="gb-body1 mr-2">
        <!-- check if it is clock or checkmark -->
        <div *ngIf="subscription.iconType === 'CLOCK'">
          <span aria-hidden="true" class="icon-ui-clock" ></span>
        </div>
        <div *ngIf="subscription.iconType === 'CHECKMARK'">
            <span aria-hidden="true" class="icon-ui-checkcircle" ></span>
        </div>
      </div>
      <div class="gb-body2 eyebrow-text" *ngIf="subscription.eyebrowText">{{subscription.eyebrowText}}</div>
    </div>
    <webu-plain-plan-template *ngFor="let plan of subscription.activePlans" [plan]="plan" [userRole]="userRole" [isVehicleOverviewPage]="isVehicleOverviewPage"></webu-plain-plan-template>

    <div class="status-bar mb-4" *ngIf="subscription.showDataUsage && serviceUsage">
      <div class="status-cit2">
        <!-- <div class="status-bar-cit2 autmoation-data-remaining-bar" role="progressbar"
          style="width: {{serviceUsage.percentRemaining}}%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div> -->
      </div>
      <div class="gb-body2 automation-data-remaining-copy">
        {{serviceUsage.quantityRemaining}} {{serviceUsage.uom}}
         <span [translate]="'onstar_wifi_remaining'"></span>
      </div>
    </div>

  </ng-container>
  <ng-container *ngIf="isFuture && subscription.upcomingPlans">
    <div class="d-flex align-items-center">
      <div class="gb-body1 mr-2">
        <span aria-hidden="true" class="icon-ui-checkcircle"></span>
      </div>
      <div class="gb-body2 eyebrow-text" *ngIf="subscription.upcomingPlans[upcomingIndex].eyebrowText">{{subscription.upcomingPlans[upcomingIndex].eyebrowText}}</div>
    </div>
    <webu-plain-plan-template *ngFor="let plan of subscription.upcomingPlans[upcomingIndex].plans" [plan]="plan" [userRole]="userRole" [isVehicleOverviewPage]="isVehicleOverviewPage"></webu-plain-plan-template>
  </ng-container>
  <!-- <div class="gb-body1" *ngIf="subscription.subscriptionDateText">
    <p class="subscription-date-text">{{subscription.subscriptionDateText}}</p>
  </div> -->
  <!-- <button ref="#" class="gb-primary-button mt-3 automation-subscription-button" *ngIf="subscription.secondaryButtonText && userRole === 'OWNER' && subscription.secondaryButtonText !== 'Manage' && !isVehicleOverviewPage"
  data-toggle="modal" (click)="secondaryButtonAction(subscription.secondaryButtonAction)">
    {{subscription.secondaryButtonText}}
  </button> -->
</div>

<!--trial plan block-->
<div *ngIf="subscription.templateType && subscription.templateType.includes('TRIAL')">

  <div *ngIf="!isTrialSecondItem">
    <div class="d-flex align-items-center">
      <div class="gb-body1 mr-2">
        <span aria-hidden="true" class="icon-ui-clock"></span>
      </div>
      <div class="gb-body2" *ngIf="subscription.eyebrowText">{{subscription.eyebrowText}}</div>
    </div>

    <div class="gb-body1 heavy mb-4" *ngIf="subscription.subHead">{{subscription.subHead}}</div>
    <div class="d-flex flex-column">

      <!-- Regular Plans -->
      <ng-container *ngIf="subscription.templateType !== 'TRIAL-EXT' && !isVehicleOverviewPage">
        <div *ngFor="let plan of subscription.activePlans; last as isLast">
          <div class="gb-body2 mb-4" *ngIf="plan.planDatesText && !isVehicleOverviewPage">{{plan.planDatesText}}</div>
          <!-- <img class="img-fluid mb-6" [src]="baseAssetsUrl + getPlanAsset(plan.planCode)?.urlPath" [alt]="getPlanAsset(plan.planCode)?.imageAltText"> -->
          <div class="gb-body1 mb-5" *ngIf="getPlanDescription(plan.planCode)">{{getPlanDescription(plan.planCode)}}</div>
          <!-- about plan info button -->
          <!-- <button ref="#" class="gb-primary-button mt-3 automation-subscription-button" *ngIf="subscription.aboutMyPlanButtonText" data-toggle="modal" (click)="secondaryButtonAction('ABOUT_PLAN', plan)">
            {{subscription.aboutMyPlanButtonText}}
          </button> -->
          <hr *ngIf="!isLast" class="cit">
        </div>
      </ng-container>

      <!-- Two Month Trial Extension Promo -->
      <ng-container *ngIf="subscription.templateType === 'TRIAL-EXT' && !isVehicleOverviewPage">
        <div *ngFor="let plan of subscription.activePlans">
          <!-- <img class="img-fluid mb-6" [src]="baseAssetsUrl + getPlanAsset(plan.planCode)?.urlPath" [alt]="getPlanAsset(plan.planCode)?.imageAltText"> -->
          <div class="gb-body1 heavy mb-1"><p class="mb-0">{{getPlanName(plan.planCode)}}</p></div>
          <div class="gb-body1 mb-6"><p class="mb-0">{{getPlanDescription(plan.planCode)}}</p></div>
          <!-- <button class="gb-primary-button" (click)="openPlanInfoModal(subscription.activePlans?.[0])" href="#">
            {{getGenericCopy('myplans.about.plan.btn.text', {'plan name': getPlanName(plan.planCode) ?? 'your plan'})}}
          </button> -->
        </div>
      </ng-container>
    </div>
  </div>
  
  <!-- Second Item Trial -->
  <div *ngIf="isTrialSecondItem && subscription.upcomingPlans && subscription.upcomingPlans.length < 1">
    <hr class="cit">
    <div class="d-flex align-items-top">
      <div class="gb-body1 mr-2">
        <span aria-hidden="true" class="icon-ui-checkcircle"></span>
      </div>
      <div class="gb-body1 mb-0" *ngIf="subscription.shopPromo">{{subscription.shopPromo?.message}}</div>
    </div>
    <!-- <button class="gb-primary-button mt-4" *ngIf="subscription.shopPromo.secondaryButtonText && subscription.secondaryButtonText !== 'Manage' && !isVehicleOverviewPage"
    (click)="secondaryButtonAction(subscription.secondaryButtonAction)" data-toggle="modal">
    {{subscription.shopPromo.secondaryButtonText}}
  </button> -->
  </div>

  <!-- Upcoming Subscriptions -->
  <div *ngIf="isTrialSecondItem && subscription.upcomingPlans && subscription.upcomingPlans.length > 0">
    <div *ngFor="let upcomingSub of subscription.upcomingPlans">
      <div class="d-flex align-items-center">
        <div class="gb-body1 mr-2">
          <span aria-hidden="true" class="icon-ui-checkcircle"></span>
        </div>
        <div class="gb-body2" *ngIf="upcomingSub.eyebrowText">{{upcomingSub.eyebrowText}}</div>
      </div>

      <div class="gb-body1 heavy mb-4" *ngIf="upcomingSub.subHead && subscription.templateType !== 'TRIAL-EXT'">{{upcomingSub.subHead}}</div>

      <div class="d-flex justify-content-between" *ngFor="let upcomingPlan of upcomingSub.plans">
        <div class="d-flex flex-column w-75">
          <div class="gb-body1 heavy mb-3">
            <!-- <a *ngIf="!isVehicleOverviewPage" (click)="openPlanInfoModal(upcomingPlan)" href="#">{{upcomingPlan.planId}}</a> -->
            <span *ngIf="isVehicleOverviewPage">{{upcomingPlan.planId}}</span>
          </div>
          <div class="gb-body1"><p>{{upcomingPlan.planDatesText}}</p></div>
        </div>
        <div *ngIf="upcomingPlan.price" class="gb-body1 heavy">${{upcomingPlan.price}}</div>
      </div>
      <!-- <button class="gb-primary-button mt-4" data-toggle="modal" *ngIf="subscription.secondaryButtonText !== 'Manage' && !isVehicleOverviewPage"
      (click)="secondaryButtonAction(subscription.secondaryButtonAction)">
      {{subscription.secondaryButtonText}}
      </button> -->
    </div>
  </div>
</div>
